export default "__VITE_ASSET__4c954015__"